"use client";

import { ReactNode, useState } from "react";
import Image from "next/image";

type MediaComboButtonProps = {
  type: "audio" | "video";
  enabled: boolean;
  onToggle: () => void;
  children: ReactNode;
};

const mediaIcons = {
  audio: { on: "/icons/mic.svg", off: "/icons/mic-off.svg" },
  video: { on: "/icons/cam.svg", off: "/icons/cam-off.svg" },
};

export function MediaComboButton({
  type,
  enabled,
  onToggle,
  children,
}: MediaComboButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const iconSrc = enabled ? mediaIcons[type].on : mediaIcons[type].off;

  return (
    <div className="relative">
      <div
        className={`flex rounded-[12px] border-2 border-[#e3d8c4] overflow-hidden ${
          enabled ? "bg-white hover:bg-[#fff3dc]" : "bg-[#f07c47]"
        } transition-colors`}
      >
        {/* Toggle button (left side) */}
        <button
          type="button"
          onClick={onToggle}
          className="flex items-center justify-center p-[13px] cursor-pointer"
        >
          <Image src={iconSrc} width={20} height={20} alt={type} />
        </button>

        {/* Dropdown button (right side) */}
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center justify-center px-[6px] cursor-pointer border-l border-[#e3d8c4]"
        >
          <Image
            src="/icons/down-small.svg"
            width={20}
            height={20}
            alt="expand"
            className={`transition-transform ${isOpen ? "rotate-180" : ""} ${
              enabled ? "" : "invert"
            }`}
          />
        </button>
      </div>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />

          {/* Popover */}
          <div className="absolute top-full mt-2 left-0 z-20 bg-white border border-[#e3d8c4] rounded-[32px] shadow-[0px_4px_4px_0px_rgba(41,37,36,0.12)] p-[20px]">
            {children}
          </div>
        </>
      )}
    </div>
  );
}
